// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1mrrv","range":"MonthRangeSwitch_range__3yINs","disabled":"MonthRangeSwitch_disabled__3OqMr"};